

















































































































































































import { defineComponent, toRefs, ref, Ref, onUnmounted, getCurrentInstance, computed } from '@vue/composition-api';
import { RollbackIcon, DeleteIcon, SecuredIcon } from 'tdesign-icons-vue';

// 引入组件
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import RefreshableHeader from '@/renderer/components/SpacePage/components/RefreshableHeader.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import {
  isAllowEditDoc,
  isAllowPreviewImage,
  isAllowPrivate,
  noPreview,
} from '@/renderer/scripts/composition/allowPreview';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { SMH } from '@/renderer/scripts/smh';
import { isAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import separateFileHandler from '../compositions/separateFileHandle';
import handleRowDetail from '../compositions/fileDetailHandler';
export default defineComponent({
  components: {
    Menu,
    MenuItem,
    RollbackIcon,
    DeleteIcon,
    RefreshableHeader,
    StatusTag,
    SecuredIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const {
      tableData,
      loadingOnHeader,
      loading: tableLoading,
      methods: initMethods,
      columns,
      loadingStatus,
      searchUpOptions,
      searchTypeOptions,
      filterParams,
    } = separateFileHandler();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      hoverIndex,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const { methods: previewMethods } = openPreviewHandler();
    const { methods: detailMethods, detailData, detailType, loading: detailLoading } = handleRowDetail();
    const showDetail = ref(false);
    const resizeColumns = ref(setResizableColumns(columns));
    // 当前表格被选中的行
    const selectItem: Ref<any> = ref();
    // 是否禁用详情可信任按钮
    const isDisabledResotre = computed(() => {
      return !detailData.value?.canMarkAsNonVirus && !detailData.value?.canMarkAsNonSensitiveWord;
    });
    // 是否禁用上方批量信任按钮
    const isDisabledBatchRestore = computed(() => {
      return (
        tableData.selectedList.length === 0 ||
        (tableData.selectedList.length === 1 &&
          !tableData.selectedList[0].canMarkAsNonVirus &&
          !tableData.selectedList[0].canMarkAsNonSensitiveWord)
      );
    });
    const methods = {
      onOperateEventProxy(command: string, item?: SMH.ContentData) {
        if (item && !item?.inDirectory) {
          tips.error(i18n_t('已被删除，请前往误删恢复找回'));
          return;
        }
        const fileItems = item ? [item] : tableData.selectedList;
        switch (command) {
          case 'detail': {
            showDetail.value = true;
            [selectItem.value] = fileItems;
            detailMethods.getDetailData(fileItems[0]);
            break;
          }
          case 'restore': {
            reporter.report('suspicious_file', { suspicious_file_trust: 'trust' });
            initMethods.onRestore(fileItems);
            break;
          }
          case 'delete': {
            reporter.report('suspicious_file', {
              suspicious_file_delete: 'delete',
            });
            const { spaceTag, userId } = fileItems[0];
            if (spaceTag === 'group') {
              const isGroupOwner =
                fileItems[0].group.userId === store.getters.userId && fileItems[0].group.orgId === store.getters.orgId;
              if (Number(userId) !== store.getters.userId && !isGroupOwner) {
                tips.error(i18n_t('可疑文件仅群主及上传者可删除'));
                return;
              }
            } else if (spaceTag === 'team') {
              if (!isAdmin.value && Number(userId) !== store.getters.userId) {
                tips.error(i18n_t('可疑文件仅管理员及上传者可删除'));
                return;
              }
            }
            initMethods.onDelete(fileItems);
            break;
          }
          default:
            break;
        }
      },
      recycleFileScope(data: any) {
        // 这个方法传过来的数据，都是用来筛选的数据
        initMethods.pullList('pull', data);
      },
      silentRefreshList() {
        initMethods.silentRefresh();
      },
      restoreFile() {
        reporter.report('suspicious_file', {
          suspicious_file_trust: 'trust',
        });
        showDetail.value = false;
        const selItem = selectItem.value;
        initMethods.onRestore([selItem]);
      },
      previewFile() {
        const item = selectItem.value;
        if (noPreview(detailData.value) || item.type === 'dir') {
          tips.error(i18n_t('该格式暂不支持在线预览'));
        } else if (isAllowPreviewImage(item.name) && +item.size >= ConstantConfig.ciImageMaxSize) {
          // 万象最大支持32mb
          tips.error(i18n_t('文件过大，请下载至本地查看'));
        } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
          if (isAllowEditDoc(item.name)) {
            tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
          } else {
            tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
          }
        } else {
          // 预览需要previewByDoc这个字段判断path，手动加上，目前只发现doc的宏病毒可能预览
          item.previewByDoc = true;
          previewMethods.openPreview(item, 1);
        }
      },
    };

    ipc.on(ipc.RENDERER_EVENTS_MAP.RECYCLE_FILE_SCOPE, methods.recycleFileScope);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.RECYCLE_FILE_SCOPE, methods.recycleFileScope);
    });

    return {
      ...toRefs(tableData),
      resizeColumns,
      tableLoading,
      loadingOnHeader,
      loadingStatus,
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      hoverIndex,
      showDetail,
      detailType,
      detailData,
      detailLoading,
      searchUpOptions,
      searchTypeOptions,
      filterParams,
      isDisabledResotre,
      isDisabledBatchRestore,
      ...methods,
      ...initMethods,
      ...listOperateMethods,
    };
  },
});
